const yup = require('yup')

const shape = {
  filename: yup.string(),
  path: yup.string().transform((v) => v.startsWith('/') ? v : '/' + v),
  bucket: yup.string(),
  width: yup.number().nullable(),
  height: yup.number().nullable(),
  size: yup.number(),
  mimetype: yup.string(),
  etag: yup.string().nullable(),
  originalfilename: yup.string(),
  originalname: yup.string().nullable(),
  numberOfPages: yup.number().nullable(),
  isFoldableBooklet: yup.boolean().nullable(),
}

const uploadSchema = yup
  .object()
  .shape(shape)
  .transform((value) => (value && !value.path && !value.filename ? null : value))
  .nullable()

module.exports = { uploadSchema }
